import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ContactForm from "./sections/ContactForm";
import LocationMap from "./sections/LocationMap";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Hero />
      <ContactForm />
      <LocationMap />
      <Footer />
    </div>;
}